<template>
    <div class="page-header-menu" :class="{opened: menuOpen}">
        <div class="container-fluid">
            <div class="hor-menu">
                <ul class="nav navbar-nav" v-if="items.length || adminItems.length">
                    <li class="mobile-user">
                        <div class="wrap">
                            <span class="ava">
                                <img alt="" class="img-circle" :src="`/img/avatar/avatar_kote.png`">
                            </span>
                            <span class="info">
                                <span class="username">{{ $root.user.name }}</span>
                                <a href="/logout" class="logout"><span class="ico"><img :src="`/images/menu-icons/log-icon.svg`" alt=""></span>Log Out</a>
                            </span>
                            <div class="menu-close" @click="closeMenu">
                                <img :src="`/images/menu-icons/close_24px.svg`" alt="">
                            </div>
                        </div>
                    </li>
                    <template v-for="(item, i) in items">
                        <template v-if="$root.user.permissions.includes(item.permission)">
                            <Li v-if="Object.hasOwn(item,'to') || Object.hasOwn(item, 'href')"
                                :to="item.to"
                                @click="closeMenu()"
                                :href="item.href"
                                :key="item.to"
                                :params="item.params"
                                class="uppercase"
                                :class="{ active: active(item) }"
                            >
                                <span class="icon">
                                    <img alt="icon" :src="item.icon" />
                                </span>
                                {{ item.name }}
                            </Li>
                            <li v-else class="menu-dropdown classic-menu-dropdown"
                                :key="i+'w'"
                                :class="{ active: active(item), opened: openedSubMenu === item.name }"
                                @click="subMenuOpen(item)"
                            >
                                <a href="#" class="uppercase"><span class="icon"><img alt="icon" :src="item.icon" /></span>{{ item.name }} <span class="arrow"></span></a>
                                <Ul :items="item.items" :parent-roles="item.roles"  @click="closeMenu()"/>
                            </li>
                        </template>
                    </template>

                    <template v-for="(item, i) in adminItems">
                        <template v-if="$root.user.permissions.includes(item.permission)">
                            <Li v-if="Object.hasOwn(item,'to') || Object.hasOwn(item, 'href')"
                                :to="item.to"
                                :href="item.href"
                                :key="item.to"
                                :params="item.params"
                                class="uppercase"
                                :class="{ active: active(item) }"
                                @click="closeMenu"
                            >
                                <span class="icon">
                                    <img alt="icon" :src="item.icon" />
                                </span>
                                {{ item.name }}
                            </Li>
                            <li v-else class="menu-dropdown classic-menu-dropdown admin-menu"
                                :key="i+'q'"
                                :class="{ active: active(item),  opened: openedSubMenu === item.name }"
                                @click="subMenuOpen(item)"
                            >
                                <a href="#" class="uppercase"><span class="icon"><img alt="icon" :src="item.icon" /></span>{{ item.name }} <span class="arrow"></span></a>
                                <Ul :items="item.items" :parent-roles="item.roles"  @click="closeMenu()"/>
                            </li>

                        </template>

                    </template>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Li from "@/js/components/_Layouts/HeaderMenu/Li.vue";
import menu from "@/js/menu";
import Ul from "@/js/components/_Layouts/HeaderMenu/Ul.vue";

export default {
    name: "AppHeaderMenu",
    components: { Li, Ul },
    props: {
        menuOpen: {
            default: false,
            type: Boolean,
        }
    },
    data: () => ({
        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,

        items: [],
        adminItems: [],
        _menuOpen: false,
        openedSubMenu: '',
    }),

    created() {
        // загружаем данные, когда представление создано
        // и данные реактивно отслеживаются
        this.fetchData();
    },
    watch: {
        menuOpen: function (val) {
            this._menuOpen = val;
        },
    },
    methods: {
        fetchData() {
            this.items = menu.items;
            this.adminItems = menu.adminItems;
        },

        active(item) {
            return this.$route.meta.group === item.metaGroup
        },
        closeMenu() {
            this.$emit('close-menu');
        },
        subMenuOpen(item) {
            if (this.openedSubMenu === item.name) {
                this.openedSubMenu = '';
                return;
            }
            this.openedSubMenu = item.name;
        }
    },
}
</script>

<style lang="scss">
@use '@/sass/variables' as *;

body.no-scroll ,html.no-scroll {
    overflow-y: hidden;
}
.page-header .page-header-menu .hor-menu .navbar-nav > li > a .icon {
    display: none;
}
.page-header .page-header-menu .hor-menu .navbar-nav > li.logout-mobile {
    display: none;
}
.fade-screen {
    //display: none;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
}
.mobile-dropdown-user {
    display: none;
}
.mobile-user {
    display: none !important;
}
@media (max-width: 991px) {
    .top-menu {
        display: none !important;
    }
    .page-header {
        .container-fluid {
            padding: 0;
            height: 100%;
        }
        .page-header-menu {
            display: block !important;
            position: fixed;
            top: 0;
            right: -100%;
            bottom: 0;
            background: #fff;
            width: 85%;
            height: 100%;
            z-index: 9999;
            box-shadow: -2px 0px 8px 0px rgba(0, 0, 0, 0.05);
            transition: all 400ms;
            &.opened {
                right: 0;
            }
            .hor-menu {
                height: 100%;
                .navbar-nav {
                    height: 100%;
                    overflow-y: auto;
                    .mobile-user {
                        border-bottom: 1px solid #F5F5F6;
                        padding: 20px;
                        display: block !important;
                        .wrap {
                            display: flex;
                            flex-direction: row;
                            position: relative;
                            .ava {
                                width: 48px;
                                height: 48px;
                                border-radius: 50%;
                                overflow: hidden;
                                margin-right: 10px;
                                img {
                                    max-width: 100%;
                                }
                            }
                            .info {
                                display: flex;
                                flex-direction: column;
                                .username {
                                    font-size: 16px;
                                    color: #1C2D3F;
                                    line-height: 22px;
                                }
                                .logout {
                                    font-size: 13px;
                                    color: #457AB2;
                                    display: flex;
                                    flex-direction: row;
                                    width: 100% !important;
                                    .ico {
                                        margin-right: 4px;
                                    }
                                }
                            }
                            .menu-close {
                                width: 24px;
                                height: 24px;
                                position: absolute;
                                top: 9px;
                                right: 20px;
                            }
                        }
                    }
                     li {
                        border-bottom: none;
                         &.logout-mobile {
                             display: block;
                         }
                        .icon {
                            margin-right: 10px;
                            display: block !important;
                        }
                        & > a {
                            padding: 10px 20px;
                            font-size: 16px;
                            color: #1C2D3F !important;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            text-transform: none !important;
                            position: relative;
                            &:focus {
                                background: none !important;
                                color: #1C2D3F !important;
                                position: relative;
                            }
                            &.logout {
                                padding: 10px 20px !important;
                                font-size: 16px;
                                color: #1C2D3F !important;
                                width: 100% !important;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                text-transform: none !important;
                            }
                            .arrow {
                                width: 24px;
                                height: 24px;
                                background: url("/images/menu-icons/arrow_drop_down_24px.svg") 50% 50% no-repeat;
                                position: absolute;
                                font-size: 0;
                                top: 11px;
                                right: 20px;
                                transform: rotate(0);
                                transition: all 400ms;
                                &:after {
                                    content: '';
                                    font-size: 0;
                                }
                            }
                        }
                         &.opened {
                             border-top: 1px solid #C2CAD8;
                             border-bottom: 1px solid #C2CAD8;
                             background:$light-blue;
                             .arrow {
                                 transform: rotate(180deg);

                                 &:after {
                                     content: '' !important;
                                 }
                             }
                         }
                         &.active > a {
                             background: none !important;
                             color: #F2784B !important;
                         }
                         &.admin-menu {
                             border-top: 1px solid #F5F5F6;
                         }
                    }
                }
            }
        }
    }
    .page-header .page-header-menu .hor-menu .navbar-nav li.classic-menu-dropdown > .dropdown-menu {
        background: $light-blue;
        margin: 0;
        box-shadow: none;
        border: none;
    }
    .page-header .page-header-menu .hor-menu .navbar-nav li.classic-menu-dropdown > .dropdown-menu > li > a {
        padding-left: 54px;
        position: relative;
        &:before {
            content: '';
            width: 6px;
            height: 6px;
            background: #1C2D3F;
            border-radius: 50%;
            position: absolute;
            left: 40px;
            top: 17px;
        }
    }
}

</style>
